import script from "./offers-info.vue?vue&type=script&setup=true&lang=js"
export * from "./offers-info.vue?vue&type=script&setup=true&lang=js"

import "./offers-info.vue?vue&type=style&index=0&id=7817459f&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7817459f"]])

export default __exports__